module.exports = __webpack_public_path__ + "img/benefit1.356db2b8.jpg";